module.exports = __webpack_public_path__ + "static/media/Gallery_Grid_6-min.916dca89.jpg";